var Component = require("/quotes-front/node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!./../../../node_modules/vue-loader/lib/selector?type=script&index=0!./../../../node_modules/eslint-loader/index.js!./Home.vue"),
  /* template */
  require("!!./../../../node_modules/vue-loader/lib/template-compiler?id=data-v-dfadb89a!./../../../node_modules/vue-loader/lib/template-loader?raw&engine=pug!./Home.pug"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/layouts/Home/Home.vue
// module id = 256
// module chunks = 2